SupportGetawaysBookingPresenterPresentation = require('./getaways_booking_presenter')
SupportGetawaysVoucherPresenterPresentation = require('./getaways_voucher_presenter')
SupportGoodsShippingPresenterPresentation = require('./goods_shipping_presenter')
SupportGoodsVoucherPresenterPresentation = require('./goods_voucher_presenter')
SupportGPassPresenterPresentation = require('./gpass_presenter')
SupportLivePresenterPresentation = require('./live_presenter')
SupportLiveVoucherPresenterPresentation = require('./live_voucher_presenter')
SupportLocalPresenterPresentation = require('./local_presenter')
SupportNowPresenterPresentation = require('./now_presenter')
SupportGetawaysMarketRatePresenterPresentation = require('./getaways_market_rate_presenter')
SupportGetawaysTonightPresenterPresentation = require('./getaways_tonight_presenter')

class SupportPresenterFactoryPresentation
  makePresenter: (order) ->
    if order?
      deal_type = order.DEAL_TYPE
      if deal_type?
        switch deal_type.toLowerCase()
          when 'goods_shipping' then new SupportGoodsShippingPresenterPresentation(order)
          when 'goods_voucher' then new SupportGoodsVoucherPresenterPresentation(order)
          when 'getaways_booking' then new SupportGetawaysBookingPresenterPresentation(order)
          when 'getaways_voucher' then new SupportGetawaysVoucherPresenterPresentation(order)
          when 'live_voucher' then new SupportLiveVoucherPresenterPresentation(order)
          when 'live'
            if order.dealOption?.isTicketedDealOption
              new SupportGPassPresenterPresentation(order)
            else
              new SupportLivePresenterPresentation(order)
          when 'local' then new SupportLocalPresenterPresentation(order)
          when 'now' then new SupportNowPresenterPresentation(order)
          when 'getaways_market_rate' then new SupportGetawaysMarketRatePresenterPresentation(order)
          when 'getaways_tonight' then new SupportGetawaysTonightPresenterPresentation(order)
          else new SupportLocalPresenterPresentation(order)

module.exports = SupportPresenterFactoryPresentation
